<template>
  <!-- Features Section -->
  <section 
  ref="sectionRef"
  class="py-20 bg-white overflow-hidden">
  
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    
    <!-- Encabezado Animado -->
    <div class="text-center mb-16 header-animate opacity-0">
      <h2 class="text-4xl font-bold text-gray-900 mb-4">¿Por qué proteger el manglar?</h2>
      <p class="text-xl text-gray-600 max-w-2xl mx-auto">
        Un ecosistema vibrante que combina biodiversidad con belleza natural
      </p>
    </div>
    
    <!-- Grid de Tarjetas -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
      
      <!-- Tarjeta 1 -->
      <div class="feature-card card-animate opacity-0
        bg-gradient-to-br from-teal-50 via-cyan-50 to-sky-50
        p-8 rounded-xl shadow-lg group"
        @mouseenter="handleMouseEnter"
        @mousemove="handleMouseMove"
        @mouseleave="handleMouseLeave"
      >
        <div
          class="card-decoration absolute -right-10 -bottom-16
                w-48 h-48 rounded-full
                bg-teal-200/20 blur-3xl
                pointer-events-none"
        ></div>
        <div class="feature-icon w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mb-6 mx-auto"> 
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"> 
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" /> 
          </svg> 
        </div>
        <h3 class="feature-title text-2xl font-bold text-gray-900 mb-4 text-center">Escudos Naturales</h3>
        <p class="feature-text text-gray-700 text-center">
          Actúan como barreras contra huracanes, marejadas y la erosión de las costas.
        </p>
      </div>    
    
      <!-- Tarjeta 2 -->
      <div class="feature-card card-animate opacity-0
          bg-gradient-to-br from-emerald-50 via-green-50 to-teal-50
          p-8 rounded-xl shadow-lg group"
          @mouseenter="handleMouseEnter"
          @mousemove="handleMouseMove"
          @mouseleave="handleMouseLeave"
      >
        <div class="absolute -right-10 -bottom-16
          w-48 h-48 rounded-full
          bg-teal-600/20 blur-3xl
          pointer-events-none"
        ></div>
        <div class="feature-icon w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mb-6 mx-auto duration-300">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"/>
          </svg>
        </div>
        <h3 class="feature-title text-2xl font-bold text-gray-900 mb-4 text-center">Pulmones del Planeta</h3>
        <p class="feature-text text-gray-700 text-center">
          Absorben hasta 10 veces más carbono que los bosques terrestres, siendo vitales contra el cambio climático.
        </p>
      </div>
    
      <!-- Tarjeta 3 -->
      <div class="feature-card card-animate opacity-0
            bg-gradient-to-br from-cyan-50 via-teal-50 to-emerald-50
            p-8 rounded-xl shadow-lg group"
            @mouseenter="handleMouseEnter"
            @mousemove="handleMouseMove"
            @mouseleave="handleMouseLeave"
      >
        <div class="absolute -right-10 -bottom-16
          w-48 h-48 rounded-full
          bg-teal-200/20 blur-3xl
          pointer-events-none"
        ></div>
        <div class="feature-icon w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mb-6 mx-auto duration-300">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418" />
          </svg>
        </div>
        <h3 class="feature-title text-2xl font-bold text-gray-900 mb-4 text-center">Cunas de Vida</h3>
        <p class="feature-text text-gray-700 text-center">
          Son el "jardín de niños" del océano; miles de especies de peces y crustáceos nacen y se protegen entre sus raíces.
        </p>
      </div>

    </div>
  </div>
</section>
</template>

<script>
import { animate, createTimeline, stagger } from 'animejs';

export default {
  name: 'FeatureSection',
  
  data() {
    return {
      observer: null,
      hasAnimated: false,
    };
  },
  
  mounted() {
    this.setupIntersectionObserver();
  },
  
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  
  methods: {
    setupIntersectionObserver() {
      const options = {
        root: null,
        threshold: 0.2,
      };
      
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.animateSequence();
            
            this.hasAnimated = true;
            
            // Ya no necesitamos observar esta sección
            this.observer.unobserve(entry.target);
          }
        });
      }, options);
      
      this.observer.observe(this.$refs.sectionRef);
    },
    
    animateSequence() {
      const section = this.$refs.sectionRef;
      const header = section.querySelector('.header-animate');
      const cards = section.querySelectorAll('.card-animate');
      const icons = section.querySelectorAll('.feature-icon');
      
      createTimeline({
        defaults: {
          ease: 'out(4)',
        },
      })
      .add(header, {
        opacity: [0, 1],
        y: [40, 0],
        scale: [0.96, 1],
        duration: 800,
      })
      .add(
      cards,
      {
        opacity: [0, 1],
        y: [70, 0],
        scale: [0.88, 1],
        rotateX: [8, 0],
        duration: 950,
        delay: stagger(140),
        ease: 'outElastic(1, .7)',
      },
      '-=350'
      )
      // Iconos
      .add(
      icons,
      {
        scale: [0.4, 1],
        rotate: [-20, 0],
        duration: 800,
        delay: stagger(100),
        ease: 'outElastic(1, .5)',
      },
      '-=700'
      );
    },
    
    handleMouseMove(event) {
      const card = event.currentTarget;

      const rect = card.getBoundingClientRect();

      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      // Posición del glow
      card.style.setProperty('--mouse-x', `${x}px`);
      card.style.setProperty('--mouse-y', `${y}px`);

      // Tilt 3D
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;

      const rotateY = ((x - centerX) / centerX) * 5;
      const rotateX = ((centerY - y) / centerY) * 5;

      card.style.transform = `
        perspective(1000px)
        rotateX(${rotateX}deg)
        rotateY(${rotateY}deg)
        scale(1.025)
      `;
    },
    
    handleMouseLeave(event) {
      const card = event.currentTarget;

      card.classList.remove('is-hovered');

      card.style.transform = `
        perspective(1000px)
        rotateX(0deg)
        rotateY(0deg)
        scale(1)
      `;

      const icon = card.querySelector('.feature-icon');
      const title = card.querySelector('.feature-title');
      const text = card.querySelector('.feature-text');

      if (icon) {
        animate(icon, {
          y: 0,
          scale: 1,
          rotate: 0,
          duration: 450,
          ease: 'out(4)',
        });
      }

      if (title) {
        animate(title, {
          y: 0,
          scale: 1,
          duration: 350,
          ease: 'out(3)',
        });
      }

      if (text) {
        animate(text, {
          y: 0,
          duration: 350,
          ease: 'out(3)',
        });
      }
    },

    handleMouseEnter(event) {
      const card = event.currentTarget;

      const icon = card.querySelector('.feature-icon');
      const title = card.querySelector('.feature-title');
      const text = card.querySelector('.feature-text');

      card.classList.add('is-hovered');

      if (icon) {
        animate(icon, {
          y: -7,
          scale: 1.12,
          rotate: 6,
          duration: 500,
          ease: 'outElastic(1, .6)',
        });
      }

      if (title) {
        animate(title, {
          y: -4,
          scale: 1.03,
          duration: 350,
          ease: 'out(3)',
        });
      }

      if (text) {
        animate(text, {
          y: -2,
          duration: 350,
          ease: 'out(3)',
        });
      }
    },
  },
};

</script>

<style scoped>
.feature-card {
  position: relative;
  overflow: hidden;
  isolation: isolate;
  
  transform-style: preserve-3d;
  perspective: 1000px;
  
  border: 1px solid rgba(13, 148, 136, 0.08);
  
  will-change: transform;
}

/* luz que sigue el mouse */
.feature-card::before {
  content: '';
  
  position: absolute;
  
  width: 280px;
  height: 280px;
  
  left: var(--mouse-x, 50%);
  top: var(--mouse-y, 50%);
  
  transform: translate(-50%, -50%);
  
  background: radial-gradient(
  circle,
  rgba(20, 184, 166, 0.22) 0%,
  rgba(16, 185, 129, 0.12) 30%,
  rgba(16, 185, 129, 0.04) 50%,
  transparent 70%
  );
  
  opacity: 0;
  
  pointer-events: none;
  
  transition:
  opacity 0.25s ease,
  width 0.35s ease,
  height 0.35s ease;
  
  z-index: 0;
}

.feature-card:hover::before, 
.feature-card::after.is-hovered::before { 
  opacity: 1;
  
  width: 400px;
  height: 400px;
}

/* brillo superior */
.feature-card::after {
  content: '';
  
  position: absolute;
  
  inset: 0;
  
  background:
  linear-gradient(
  120deg,
  transparent 20%,
  rgba(255, 255, 255, 0.35) 45%,
  transparent 65%
  );
  
  transform: translateX(-120%);
  
  pointer-events: none;
  
  transition: transform 0.7s ease;
  
  z-index: 1;
}

.feature-card:hover,
.feature-card.is-hovered {
  border-color: rgba(13, 148, 136, 0.25);

  box-shadow:
    0 20px 45px rgba(13, 148, 136, 0.14),
    0 8px 20px rgba(0, 0, 0, 0.06);
}

.feature-card:hover::after {
  transform: translateX(120%);
}

/* contenido por encima de los efectos */
.feature-card > * {
  position: relative;
  z-index: 2;
}

.feature-icon,
.feature-title,
.feature-text {
  position: relative;
  z-index: 2;
}

.card-decoration {
  z-index: 0;
}

.feature-icon {
  box-shadow:
  0 8px 25px rgba(13, 148, 136, 0.18);
}
</style>